import React, { useState, useEffect } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";
import imgUrl from "../../../images/chocolate.webp"

const TITLE = "Calculatrice Chocolat - Calculez les Calories et les Nutriments";
const DESCRIPTION =
  "Calculatrice Chocolat - Calculez les Calories et les Nutriments pour adapter vos recettes, portions et conversions en cuisine. Resultat rapide et pratique pour cuisiner avec plus de precision chaque jour.";
const KEYWORDS =
  "chocolat les calories et les nutriments, calculatrice chocolat les calories et les nutriments, calcul en ligne, cuisine, recette, conversion, resultat rapide";
const OG_URL = "https://do-calculate.com/calculator/fr/chocolate-calculator/";

const SCHEMA = [
    {
        "@context": "https://schema.org",
        "@type": "WebApplication",
        name: "Calculatrice Chocolat",
        description: DESCRIPTION,
        url: OG_URL,
        applicationCategory: "HealthApplication",
        operatingSystem: "Any",
        offers: {
            "@type": "Offer",
            price: "0",
            priceCurrency: "USD",
        },
    },
    {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: [
            {
                "@type": "ListItem",
                position: 1,
                name: "Accueil",
                item: "https://do-calculate.com/",
            },
            {
                "@type": "ListItem",
                position: 2,
                name: "Calculatrices",
                item: "https://do-calculate.com/fr/all-calculators/",
            },
            {
                "@type": "ListItem",
                position: 3,
                name: "Calculatrice Chocolat",
                item: OG_URL,
            },
        ],
    },
    {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: [
            {
                "@type": "Question",
                name: "Combien de calories dans 100 grammes de chocolat noir ?",
                acceptedAnswer: {
                    "@type": "Answer",
                    text: "Le chocolat noir (70-85% cacao) contient en moyenne environ 598 calories pour 100 grammes, et se distingue par sa richesse en fibres et minéraux comparé à d'autres types.",
                },
            },
            {
                "@type": "Question",
                name: "Le chocolat blanc contient-il du cacao ?",
                acceptedAnswer: {
                    "@type": "Answer",
                    text: "Le chocolat blanc contient du beurre de cacao mais pas de solides de cacao (qui donnent la couleur brune), donc il manque les antioxydants présents dans le chocolat noir.",
                },
            },
        ],
    },
];

const CHOCOLATE_DATA = {
    dark: { name: "Chocolat noir (70-85%)", calories: 5.98, fat: 0.43, sugar: 0.24, protein: 0.08 },
    milk: { name: "Chocolat au lait", calories: 5.35, fat: 0.30, sugar: 0.51, protein: 0.08 },
    white: { name: "Chocolat blanc", calories: 5.39, fat: 0.32, sugar: 0.59, protein: 0.06 },
    cocoa_powder: { name: "Poudre de cacao (non sucrée)", calories: 2.28, fat: 0.14, sugar: 0.02, protein: 0.20 },
};

function ChocolateCalculator() {
    const [type, setType] = useState("dark");
    const [weight, setWeight] = useState("");
    const [unit, setUnit] = useState("g");
    const [result, setResult] = useState(null);
    const [error, setError] = useState("");

    const calculateResult = () => {
        setError("");
        const w = parseFloat(weight);
        if (!w || w <= 0) {
            setResult(null);
            return;
        }

        const weightInGrams = unit === "oz" ? w * 28.3495 : w;
        const data = CHOCOLATE_DATA[type];

        setResult({
            calories: weightInGrams * data.calories,
            fat: weightInGrams * data.fat,
            sugar: weightInGrams * data.sugar,
            protein: weightInGrams * data.protein,
            weightG: weightInGrams,
            typeName: data.name,
        });
    };

    useEffect(() => {
        calculateResult();
    }, [type, weight, unit]);

    const handleClear = () => {
        setType("dark");
        setWeight("");
        setUnit("g");
        setResult(null);
        setError("");
    };

    const renderInputFields = () => (
        <div className="row">
            <div className="col-sm-12 col-md-6">
                <label >Type de Chocolat</label>
                <select
                    className="form-select"
                    value={type}
                    onChange={(e) => setType(e.target.value)}
                >
                    {Object.entries(CHOCOLATE_DATA).map(([key, val]) => (
                        <option key={key} value={key}>{val.name}</option>
                    ))}
                </select>
            </div>
            <div className="col-sm-12 col-md-4">
                <label >Poids / Quantité</label>
                <input
                    type="number"
                    className="form-control"
                    value={weight}
                    onChange={(e) => setWeight(e.target.value)}
                    placeholder="Entrez la quantité"
                />
            </div>
            <div className="col-sm-12 col-md-2">
                <label >Unité</label>
                <select
                    className="form-select"
                    value={unit}
                    onChange={(e) => setUnit(e.target.value)}
                >
                    <option value="g">Gramme (g)</option>
                    <option value="oz">Once (oz)</option>
                </select>
            </div>
        </div>
    );

    return (
        <div className="ltr" style={{ direction: "ltr" }}>
            <SharedHelmet
                TITLE={TITLE}
                DESCRIPTION={DESCRIPTION}
                KEYWORDS={KEYWORDS}
                OG_URL={OG_URL}
                SCHEMA={SCHEMA}
                IMAGE={imgUrl}
            />
            <div className="row">
                <div className="col-12 col-md-8">
                    <FirstAds />
                </div>
                <div className="col-12 col-md-4">
                    <img src={imgUrl} alt="Calculatrice Chocolat - Calculez les Calories et les Nutriments"
                        width="350px"
                        height="300px"

                    />
                </div>
            </div>
            <div className="row">
                <div className="col-12 col-md-8">
                    <br />
                    <div className="bg-success text-white text-center" style={{ padding: "15px", borderRadius: "5px" }}>
                        <h1 style={{ fontSize: "22px", margin: 0 }}>Calculatrice Chocolat et Valeurs Nutritionnelles</h1>
                    </div>
                    <div className="border border-light mt-3 p-3 bg-white shadow-sm">
                        <div className="mb-4">
                            <p style={{ fontSize: "16px", lineHeight: "1.8" }}>
                                La <strong>calculatrice chocolat</strong> est un outil idéal pour les amateurs de sucreries et ceux intéressés par la remise en forme, car elle vous permet de connaître <strong>les calories</strong> et la teneur en sucre et matières grasses avec précision dans votre portion quotidienne. Que vous préfériez le chocolat noir pour ses bienfaits pour la santé ou le chocolat au lait pour son goût riche, cette calculatrice vous aide à équilibrer votre régime alimentaire sans privation.
                            </p>
                        </div>
                        <hr />
                        <MobileUnderCalAds />
                        <div className="calculatorStyle mb-4">
                            <div className="p-3 mb-3 bg-success text-white text-center rounded">
                                <h2 style={{ fontSize: "18px", margin: 0 }}>Données de Portion de Chocolat</h2>
                            </div>
                            {renderInputFields()}
                            <div className="text-center mb-3 mt-4">
                                <button onClick={handleClear} className="btn btn-secondary" style={{ fontSize: "16px", padding: "10px 30px" }}>
                                    Effacer les Données
                                </button>
                            </div>
                            {result && (
                                <div className="mt-4">
                                    <h3 style={{ fontSize: "18px", marginBottom: "15px", textAlign: "center" }}>
                                        <strong>Résultats Nutritionnels pour {result.weightG.toFixed(1)} Grammes :</strong>
                                    </h3>
                                    <div className="mb-3">
                                        <table className="table bmi-table" style={{ width: "100%" }}>
                                            <thead>
                                                <tr>
                                                    <th className="bmi-header" style={{ textAlign: "center" }}>Élément Nutritif</th>
                                                    <th className="bmi-header" style={{ textAlign: "center" }}>Valeur</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td style={{ textAlign: "center" }}>Énergie (Calories)</td>
                                                    <td style={{ textAlign: "center", fontWeight: "bold", color: "#1a5f3f" }}>{result.calories.toFixed(1)} kcal</td>
                                                </tr>
                                                <tr>
                                                    <td style={{ textAlign: "center" }}>Total des Graisses</td>
                                                    <td style={{ textAlign: "center" }}>{result.fat.toFixed(2)} g</td>
                                                </tr>
                                                <tr>
                                                    <td style={{ textAlign: "center" }}>Sucre</td>
                                                    <td style={{ textAlign: "center" }}>{result.sugar.toFixed(2)} g</td>
                                                </tr>
                                                <tr>
                                                    <td style={{ textAlign: "center" }}>Protéine</td>
                                                    <td style={{ textAlign: "center" }}>{result.protein.toFixed(2)} g</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>Conseils d'utilisation</h3></div>
              <div className="info-section-body">
                <p>Pour obtenir un resultat pertinent, verifiez vos unites, saisissez des valeurs realistes et utilisez ce calcul comme aide a la decision, puis adaptez selon votre situation.</p>
              </div>
            </div>
                                        <div className="info-section">
                                            <div className="info-section-header"><strong>Détails du Calcul</strong></div>
                                            <div className="info-section-body">
                                                <p>Basé sur <strong>{result.typeName}</strong> :</p>
                                                <p>Calories = Poids × Facteur d'Énergie</p>
                                                <p>Graisses = Poids × Ratio de Graisses Standard</p>
                                                <div className="alert alert-info mt-3" style={{ fontSize: "14px" }}>
                                                    <strong>💡 Information :</strong> Le chocolat noir contient parfois plus de calories en raison de la concentration de beurre de cacao, mais son sucre est beaucoup moins élevé.
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                        <hr />
                        <div className="row">
                            <RelatedLinks />
                        </div>
                    </div>
                </div>
                <div className="col-sm-12 col-md-4">
                    <SecondAds />
                    <br />
                    <MainCalculatorsList />
                </div>
            </div>

            <div className="row" style={{ marginTop: "20px" }}>
                <div className="col-12 col-md-8">
                    <div className="info-sections-container">
                        <div className="info-section">
                            <div className="info-section-header"><strong>Qu'est-ce que la Calculatrice Chocolat ?</strong></div>
                            <div className="info-section-body">
                                <p>La calculatrice chocolat est un outil numérique conçu pour estimer le contenu nutritionnel de différents produits à base de cacao. Pour l'utiliser, il vous suffit de sélectionner le type de chocolat que vous consommez, puis d'entrer le poids en grammes ou en onces. La calculatrice analyse immédiatement les données et fournit un rapport détaillé sur les calories, les graisses et les sucres, ce qui vous aide à prendre des décisions alimentaires saines et éclairées tout en faisant vos courses ou en préparant des sucreries.</p>
                            </div>
                        </div>

                        <div className="info-section">
                            <div className="info-section-header"><strong>Utilisations de la Calculatrice dans votre Vie Quotidienne</strong></div>
                            <div className="info-section-body">
                                <ul>
                                    <li><strong>Suivi du Régime :</strong> Surveillez précisément les calories pour éviter une prise de poids.</li>
                                    <li><strong>Cuisson de Sucreries :</strong> Calculez les valeurs nutritionnelles gâteaux et brownies pour des quantités spécifiques de chocolat.</li>
                                    <li><strong>Pour les Diabétiques :</strong> Estimez la quantité de sucre dans une portion pour choisir les types les plus appropriés.</li>
                                    <li><strong>Amélioration des Performances Sportives :</strong> Connaître l'énusie obtenue du chocolat noir avant les exercices intensifs.</li>
                                </ul>
                            </div>
                        </div>

                        <div className="info-section">
                            <div className="info-section-header"><strong>Faits Nutritionnels sur les Types de Chocolat</strong></div>
                            <div className="info-section-body">
                                <table className="table bmi-table">
                                    <thead>
                                        <tr>
                                            <th>Type</th>
                                            <th>Calories (pour 100 g)</th>
                                            <th>Avantage Principal</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>Noir (70-85%)</td>
                                            <td>598</td>
                                            <td>Antioxydants élevés</td>
                                        </tr>
                                        <tr>
                                            <td>Au Lait</td>
                                            <td>535</td>
                                            <td>Goût plus sucré</td>
                                        </tr>
                                        <tr>
                                            <td>Blanc</td>
                                            <td>539</td>
                                            <td>Doux et crémeux</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ChocolateCalculator;
